<app-header></app-header>
<mat-sidenav-container class="main min-h-[calc(100svh-64px)]">
  <mat-sidenav class="px-4 py-6 w-fit!" mode="side" opened>
    <div class="flex flex-col h-full">
      <div class="mb-4 w-fit">
        <mat-nav-list class="w-fit" [class.w-52]="!isSideNavCollapsed">
          <mat-list-item class="mb-1" routerLink="dashboard" routerLinkActive="active"
            *appHasPermission="['hierarchy', 'read']">
            <mat-icon class="align-middle">dashboard</mat-icon>
            @if (!isSideNavCollapsed) {
            <span class="truncate">Dashboard</span>
            }
          </mat-list-item>
          <mat-list-item routerLink="home" routerLinkActive="active">
            <mat-icon class="align-middle">home</mat-icon>
            @if (!isSideNavCollapsed) {
            <span class="truncate">Home</span>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>
      <div class="mb-4">
        @if (!isSideNavCollapsed) {
        <h2 class="!mb-1 px-4 title-medium">Manage</h2>
        } @else {
        <h2 class="!mb-1 title-small">Manage</h2>
        }
        <mat-nav-list class="w-fit" [class.w-52]="!isSideNavCollapsed">
          <mat-list-item routerLink="submissions" routerLinkActive="active">
            <mat-icon class="align-middle">view_agenda</mat-icon>
            @if (!isSideNavCollapsed) {
            <span class="truncate">My Submissions</span>
            }
          </mat-list-item>
          <mat-list-item class="mt-1" routerLink="board" routerLinkActive="active"
            *appHasPermission="['hierarchy', 'read']">
            <mat-icon class="align-middle">view_list</mat-icon>
            @if (!isSideNavCollapsed) {
            <span class="truncate">Reviewer Board</span>
            }
          </mat-list-item>
          <mat-list-item class="mt-1" routerLink="users" routerLinkActive="active"
            *appHasPermission="['user', 'read']">
            <mat-icon class="align-middle">group</mat-icon>
            @if (!isSideNavCollapsed) {
            <span class="truncate">User Management</span>
            }
          </mat-list-item>
          <mat-list-item class="mt-1" routerLink="change-requests" routerLinkActive="active"
            *appHasPermission="['user', 'read']">
            <mat-icon class="align-middle">swap_horiz</mat-icon>
            @if (!isSideNavCollapsed) {
            <span class="truncate">Change Requests</span>
            }
          </mat-list-item>
          <mat-list-item class="mt-1" routerLink="auto-approval-history" routerLinkActive="active"
            *appHasPermission="['submission', 'auto_approve']" matTooltip="Auto-Approval History"
            [matTooltipDisabled]="isSideNavCollapsed">
            <mat-icon class="align-middle">history</mat-icon>
            @if (!isSideNavCollapsed) {
            <span class="truncate">Auto-Approvals</span>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>
      <span class="flex-1"></span>
      <div class="flex flex-row justify-end">
        <button mat-icon-button (click)="toggleSideNav()" [matTooltip]="isSideNavCollapsed ? 'Expand' : 'Collapse'">
          <mat-icon>
            @if (!isSideNavCollapsed) {
            keyboard_double_arrow_left
            } @else {
            keyboard_double_arrow_right
            }
          </mat-icon>
        </button>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="rounded-2xl overflow-hidden" [class.collapsed]="isSideNavCollapsed">
    <app-http-event-loader></app-http-event-loader>
    <div class="main-container">
      <app-main>
        <router-outlet></router-outlet>
      </app-main>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>